import React, { useState } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Checkbox } from "@mui/material"; // Ensure MUI is available or use standard input
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";

const LeaveEncashmentTable = ({ data, onViewDetail, selectedIds, setSelectedIds }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const headers = ["Select", "ID", "Full Name", "Total Balance", "Encashable", "Total Value", "Actions"];
  const accessors = ["selection", "employeeId", "fullName", "totalLeaveBalance", "totalEncashable", "totalGross", "actions"];

  const toggleAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(data.map(emp => emp.id));
    } else {
      setSelectedIds([]);
    }
  };

  const toggleOne = (id) => {
    setSelectedIds(prev => 
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const actions = [
    {
      tooltip: "View Details",
      icon: <VisibilityIcon fontSize="small" />,
      color: "bg-blue-600",
      visible: true,
      function: (row) => onViewDetail(row),
    }
  ];

  const customCellRenderer = (row, accessor) => {
    if (accessor === "selection") return (
        <Checkbox 
            checked={selectedIds.includes(row.id)} 
            onChange={() => toggleOne(row.id)} 
            size="small"
        />
    );
    if (accessor === "totalGross") return <span className="text-blue-800 font-extrabold">₱{row[accessor].toLocaleString()}</span>;
    if (accessor === "totalEncashable") return <span className="font-bold">{row[accessor]} Days</span>;
    return null;
  };

  return (
    <CreateTable
      tableName="LeaveSummaryTable"
      headers={headers.map(h => h === "Select" ? <Checkbox onChange={toggleAll} checked={selectedIds.length === data.length && data.length > 0} size="small" /> : h)}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data.length}
      customCellRenderer={customCellRenderer}
    />
  );
};

export default LeaveEncashmentTable;